
import { useEffect,useState } from "react";
// import "./Reports.css"
// import useAuth from "../../Hooks/UseAuth";
import { DateRangePicker } from 'react-date-range';
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";
import {addDays} from "date-fns";
import format from "date-fns/format";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file


function AdvanceReports(){  
    const[tData, setTData] = useState([]);
    const[sData, setSData] = useState([]);
    const[visible, setVisible] = useState(false);
    const auth = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const[drange, setDrange] = useState([{
        startDate: new Date(),
        endDate: addDays(new Date(),7),
        key: 'selection',
        
    }]);
    // const {auth} = useAuth(); 
    // const [authname, setAuthname] = useState(auth.dat.name);
    const [zra,setZra] = useState();
    const [napsa,setNapsa] = useState(75);
    const [dedtSum,setDeductSum] = useState();
    const [earnSum,setEarnSum] = useState(0);
    const[basepay, setBasepay] = useState();
    const [users, setUsers] = useState();
          

    //   dedtSum = zra+napsa;

//     async function populateData(){  

//         // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
//         const response = await fetch("https://nerdayb.onrender.com/api/PayReports",{
//             headers : { 
//             //   'x-access-token' : auth.user,
//               }
//           // body: JSON.stringify({
//           //     quote,
              
//           // })
//         })
        
//         const data = await response.json();
//         console.log("All Data here",data.propdata)
//         if(data){

//        if(data.status == "ok") {
//           setTData(data.propdata)
//         }else{
      
//            console.log("testign first")
//         } 

//      }
        
//         return data;
        
//   } 

//   useEffect(()=>{ 

//      populateData();
//      console.log("test populate");

//   },[])




const handleFilter = (event) =>{ 
    console.log(event.target.value);
    const searchWord = event.target.value;
    const newFilter = searchData.filter((value)=>{
        console.log("searchWord",searchWord)
         return value?.name?.toLowerCase().includes(searchWord.toLowerCase());
          
    })

    setFildata(newFilter);
}






  const setRangeViz = () =>{
    setVisible(!visible)

}

// useEffect(() => {
//     let isMounted = true;
//     const controller = new AbortController();

//     const getUsers = async () => {
//         try {
//             const response = await axiosPrivate.get('/users', {
//                 signal: controller.signal
//             });
//             console.log(response.data);
//             console.log("Heresummary");
//             isMounted && setUsers(response.data);
//             // setTData(response?.data)
//             setSearchData(response?.data)
//         } catch (err) {
//             console.error(err);
//           //   navigate('/login', { state: { from: location }, replace: true });
//         }
//     }
//     console.log("contect",auth)
//     getUsers();

//     return () => {
//         isMounted = false;
//         controller.abort();
//     }
// }, [])



 
useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
        try {
            const response = await axiosPrivate.get('/users', {
                signal: controller.signal,
                params: {
                
                    Org: auth.auth.foundUser.Org,
                    // org: 'value2',
                    // mgtLvl: 'value2',
                  }
                
            });
            console.log(response.data);
            console.log("Heresummary");
            isMounted && setUsers(response.data);
            // setTData(response?.data)
            setSearchData(response?.data)
        } catch (err) {
            console.error(err);
          //   navigate('/login', { state: { from: location }, replace: true });
        }
    }
    console.log("contect",auth)
    getUsers();

    return () => {
        isMounted = false;
        controller.abort();
    }
}, [])







useEffect(()=>{
    console.log("ranges",drange)
},[drange])


//////////////////////
const [searchData, setSearchData] = useState(""); 
const [fildata, setFildata] = useState([]); 
const [userData, setUserData] = useState([]); 
const[rData, setRData] = useState([]);
const[tax, setTax] = useState(0);
var dedSum = 0; 
var allwSum = 0; 
var zraTax = 0; 
var allwrep = 0;



  const [value, setValue] = useState(
      { 
  
          Locat : '',
          Fromto : "",
          Message : ""
  
      }
  )
  const [inpV, setInpV] = useState("");

//   const handleFilter = (event) =>{ 
//       console.log(event.target.value);
//       const searchWord = event.target.value;
//       const newFilter = searchData.filter((value)=>{
//           console.log("searchWord",searchWord)
//            return value.name.toLowerCase().includes(searchWord.toLowerCase());
            
//       })

//       setFildata(newFilter);
//  }





//   async function populateDataSec(){  

//       // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
//       const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
//           headers : { 
    
//           }
      
//       })
      
//       const data = await response.json();
//       console.log("All Data here",data.propdata)

//       if(data){

//         if(data.status == "ok") {

//             // const[sData, setSData] 
//             // setTData(data.propdata)
//             setSearchData(data.propdata)
//             console.log("Data here",data)
//             }else{
//             //    alert(data.error,"Here!")
//             console.log("testign first")
//             } 

//         }
        

  
//   return data;
  
// } 

useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    // http://localhost:2000/txns/AdmnTXNS

    const getUsers = async () => {
        try {
            const response = await axiosPrivate.get('/txns', {
                signal: controller.signal,
                params: {
                //   email: auth.user,
                //   Org: auth.foundUser.Org,
                //   mgtLvl: 'value2',
                }
            });
            // console.log(response.data);
            if(response?.data){
                console.log("Here new again");
               // setSearchData(response?.data.propdata)
                setTData(response?.data?.propdata);
            console.log("response",response)
            }
            
          //   isMounted && setUsers(response.data);
        } catch (err) {
            console.error(err);
          //   navigate('/login', { state: { from: location }, replace: true });
        }
    }
    console.log("contect",auth)
    getUsers();
    console.log("teadaa",tData)

    return () => {
        isMounted = false;
        controller.abort();
    }
}, [])




            // useEffect(()=>{ 

            // populateDataSec();
            // console.log("test populate");

            // },[]) 

            const handleSelected = (item) =>{
                
            
                setUserData(item)


            }



    return( 

        <>  
            <div className="CompensationCard">

                        <div className="cardHeading"><h2>Deductions Report</h2></div>
                        <div className="filterInputsContainer">

                        <div className="filterButton">
                            {/* Time filter */}

                            <input className="fromTo"
                               onClick={setRangeViz}
                               placeholder="All time"
                               value={`${format(drange[0].startDate,"dd/MM/yyyy")} to ${format(drange[0].endDate,"dd/MM/yyyy")}`}
                               type="text"
                               readOnly
                            >
                            </input>
                        
                            <div className={visible? "visible":"notVisible"}>
                                <h1></h1>
                                <DateRangePicker
                                        ranges={drange}
                                        onChange={item => setDrange([item.selection])}
                                        editableDateInputs={true}
                                        moveRangeOnFirstSelection={false}
                                        direction={'horizontal'}
                                        months={2}

                                    />

                            </div>
                             
                               
                        </div>

                             {/* Name search input field */}
                             <div className='searchBar'>  
                                
                                <div className='searchInputs'>
                                    <input type="text" name='Locat' onChange = {handleFilter} />
                                    <div className='ssearchIcon'> <i class="fa-solid fa-magnifying-glass"></i></div>

                                    { 
                                    fildata.length > 0 && 
                                    (

                                    <div className='dataResults'>
                                    {
                                    searchData && 
                                    
                                    fildata.map((index,key)=>{
                                        
                                        return (
                                        <div onClick={()=>handleSelected(index)} ><a key={key} className='datItem'>{index.name}</a></div>
                                        
                                        )
                                    
                                    })} 
                                
                                </div>


                                    )
                                }

                                </div>
                                </div>
                        </div>

                        
                        <div className="payReport">
                                {/* <div className="prHeading">
                                        <div><p><b>Payslip</b></p></div>
                                        <div><p>Payment slip for the month of Janury 2021</p></div>
                                </div> */}
                                <div className="empDetailsContainer">
                                    <div className="empDetails">
                                        <div><p><b>Employee Name:</b></p></div>
                                        <div><p>{userData.name}</p></div>
                                    </div>
                                    <div className="empDetails">
                                        <div><p><b>Account_N0:</b></p></div>
                                        <div><p>{userData.AccountNo}</p></div>
                                    </div>
                                    <br/>
                                    {/* <div className="empDetails">
                                        <div><h3>Designation:</h3></div>
                                        <div><p>Chef</p></div>
                                    </div> */}


                                


                                </div>
                            

                            </div>
                      
                        <div className="compensationCard">

                         
                            <h3>Deductions</h3>
                            <table className="contentTable"> 
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Requester</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Purpose</th>
                                        <th>Brought - Forward</th>
                                        <th>Current Brought - Forward</th>
                                        {/* <th>TID</th>
                                        <th>Recepient</th> */}

                                        

                                        
                                    </tr>
                                </thead>
                                <tbody>

                                    

                                      {tData && tData
                                      .filter((row,index)=>{



                                        const date = new Date(row.TDate);
                                        // Checks if the data is within the filter range
                                        if ((drange[0].endDate > date) &&(drange[0].startDate < date)
                                         &&(row.txnID == userData._id) && (row.transactionType == "Deduction")) {
                                         //&&(row.TAccount == userData.AccountNo) && (row.transactionType == "Deduction")) {
                                        
                                               // "Advance Request","Advance Repayment"
                                          
                                            return row;
                                        }
                                        
                                      })
                                      .map((item,index)=>{
                                     
                                   
                                     allwSum = allwSum + item.transactionAmount;

                                      var isod =  new Date(item.TDate).toISOString();
                                    //   var dates = format(isod, 'yyyy-MM-dd') 
                                    //    var datee = new Date(item.TDate)
                                    //    console.log("Date here",isod.toString().substring(2, 10))
                                    return(  
                                    <tr>

                                        <td>{index+1}</td>
                                        <td>{item.TAccount} </td>
                                        <td>{isod.toString().substring(2, 10)}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{item.transactionAmount}</td>
                                        <td>{item.Notes}</td>
                                        <td>{item.AccBFPrev}</td>
                                        <td>{item.AccBFCurrent}</td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  )
                                })} 

                                       <tr>

                                        <td><b>{"Total Deductions:"}</b></td>
                                        <td>{""} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{""}</td>
                                        <td>{""}</td>
                                        <td>{""}</td>
                                        <td><b>{`ZMK ${allwSum}`}</b></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  
                                
                                </tbody>
                            </table>

                            {/* <div className="netPay">
                                <div><b>Balance_BF:</b></div>
                                <div><p>{`_ ZMK ${userData.Advance_BF} `}</p></div>
                            </div>
                            */}

                        </div>

                          <div className="compensationCard">

                         
                            <h3>Repayments</h3>
                            <table className="contentTable"> 
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Requester</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Purpose</th>
                                        <th>Brought - Forward</th>
                                        <th>Current Brought - Forward</th>
                                        {/* <th>TID</th>
                                        <th>Recepient</th> */}

                                        

                                        
                                    </tr>
                                </thead>
                                <tbody>

                                    

                                      {tData && tData
                                      .filter((row,index)=>{



                                        const date = new Date(row.TDate);
                                        // Checks if the data is within the filter range
                                        if ((drange[0].endDate > date) &&(drange[0].startDate < date)
                                         &&(row.txnID == userData._id) && (row.transactionType == "Deduction Repayment")) {
                                         //&&(row.TAccount == userData.AccountNo) && (row.transactionType == "Deduction Repayment")) {
                                        
                                               // "Advance Request","Advance Repayment"
                                                // Deduction","Deduction Repayment"
                                          
                                            return row;
                                        }
                                        
                                      })
                                      .map((item,index)=>{
                                     
                                   
                                     allwrep = allwrep + item.transactionAmount;

                                      var isod =  new Date(item.TDate).toISOString();
                                    //   var dates = format(isod, 'yyyy-MM-dd') 
                                    //    var datee = new Date(item.TDate)
                                    //    console.log("Date here",isod.toString().substring(2, 10))
                                    return(  
                                    <tr>

                                        <td>{index+1}</td>
                                        <td>{item.TAccount} </td>
                                        <td>{isod.toString().substring(2, 10)}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{item.transactionAmount}</td>
                                        <td>{item.Notes}</td>
                                        <td>{item.AccBFPrev}</td>
                                        <td>{item.AccBFCurrent}</td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  )
                                })} 

                                       <tr>

                                        <td><b>{"Total Repayment:"}</b></td>
                                        <td>{""} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{""}</td>
                                        <td>{""}</td>
                                        <td>{""}</td>
                                        <td><b>{`ZMK ${allwrep}`}</b></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}

{/* AccBFPrev : user.Advance_BF,
                            transactionID : user._id,
                            AccBFCurrent : parseInt(user.Advance_BF) - parseInt(req.body.amount), */}
                                        
                                    </tr>
                                  
                                
                                </tbody>
                            </table>

                            <div className="netPay">
                                <div><b>Balance_Brought Down:</b></div>
                                <div><p>{`_ ZMK ${userData.Advance_BF} `}</p></div>
                            </div>
                           

                        </div>


              
                
                
                </div>
        </>
    )

}

export default AdvanceReports;